import { CSSObject } from "@emotion/react";
import {
  constants,
  typographyStyles,
  type CheckboxStyleOverrides,
  type AngelouCSS,
} from "@newsela/angelou";

const { textSObj, textXSObj, textMObj } = typographyStyles;
const greyLight = constants.colors.ui.neutral[50];
const neutral = constants.colors.ui.neutral[700];

interface ModalStyleOverrides<T> {
  root: T;
  scrollableBody: T;
  footer: T;
  modalContentWrapper: T;
}

export const modalCss = (
  hideOverflow: boolean,
): ModalStyleOverrides<AngelouCSS> => ({
  root: {
    zIndex: 16,
    overflow: hideOverflow ? "hidden" : "auto",
  },
  modalContentWrapper: {
    "&&": {
      maxWidth: "1184px",
    },
  },
  scrollableBody: {
    padding: "0 !important",
    height: "100%",
  },

  footer: {
    maxHeight: "268px",
    padding: "16px",
  },
});

export const listItemCss = (disabled?: boolean): CSSObject => ({
  listStyle: "none",
  borderBottom: `1px solid ${greyLight}`,
  padding: "12px 32px",
  opacity: disabled ? 0.4 : 1,

  "> div": {
    display: "flex",
    alignItems: "center",
  },
});

export const checkboxCss: CheckboxStyleOverrides<AngelouCSS> = {
  root: {
    padding: 0,
  },

  labelText: {
    ...textMObj,
    marginTop: "-3px",
    color: neutral,
  },
};

export const standardDescriptionCss: CSSObject = {
  ...textSObj,
  color: neutral,
  margin: 0,
  marginTop: "-2px",
  paddingLeft: "35px",
};

export const gradeTextCss: CSSObject = {
  ...textXSObj,
  color: neutral,
  paddingLeft: "36px",
  marginTop: "-5px",
};
